module.exports = __webpack_public_path__ + "static/media/OfferBook_ios_6.423150f9.jpg";